import React from "react";
import { THEMES, THEME_SHORT, currentTheme, setUserTheme, useTheme, userMayChoose } from "@/lib/uiTheme";

/** Alegerea individuală a aspectului (din meniul utilizatorului), doar dacă Adminul a permis-o. Aceleași pagini, alt aspect. */
export default function ThemePicker({ style }) {
  const theme = useTheme();
  if (!userMayChoose()) return null;
  return (
    <div data-testid="theme-toggle" style={{ marginBottom: 8, ...style }}>
      <div style={{ fontSize: 11, opacity: 0.7, textTransform: "uppercase", letterSpacing: ".04em", marginBottom: 4 }}>Aspect</div>
      <div style={{ display: "flex", gap: 6 }}>
        {THEMES.map(t => (
          <button key={t} type="button" className={"btn " + (theme === t ? "btn-primary" : "btn-secondary")} data-testid={`theme-${t}`}
            style={{ flex: 1, justifyContent: "center", padding: "5px 6px", fontSize: 12, minHeight: 0 }} aria-pressed={theme === t}
            onClick={() => setUserTheme(t)}>{THEME_SHORT[t]}</button>))}
      </div>
    </div>
  );
}
export { currentTheme };
